// router.pathname 은 Next.js Pages Router의 라우트 템플릿이라 동적 세그먼트가
// 값이 아닌 대괄호 그대로 온다(예: 실제 URL '/board/42' → pathname '/board/[boardId]').
const EXCLUDED_PATH_PREFIXES = [
  '/auth',
  '/sign-up',
  '/login',
  '/verification-phone',
  '/checkout',
  '/lti',
  '/board/[boardId]',
  '/play',
];

export const isPhoneVerificationPromptRouteEligible = ({
  isInExternalPlatform,
  pathname,
}: {
  isInExternalPlatform: boolean;
  pathname: string;
}) =>
  !isInExternalPlatform &&
  !EXCLUDED_PATH_PREFIXES.some(prefix => pathname.startsWith(prefix));
